import BasicInput from './BasicInput.vue'

export { BasicInput }
export default BasicInput
